import { ReactNode } from 'react'

import { clsx } from 'clsx'

import { Tooltip } from '../../Tooltip/index.js'

export interface ActionAddonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  label?: string
}

export function ActionAddon({
  children,
  label,
  className,
  ...buttonProps
}: ActionAddonProps) {
  return (
    <div className="flex px-2 first:ps-0 last:pe-0">
      <Tooltip>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            className={clsx(
              'p-0.5',
              'transition duration-200',
              'text-content-subdued hover:text-content',
              'focus:outline-none focus-visible:ring',
              'rounded-base',
              className,
            )}
            {...buttonProps}
          >
            {children}
          </button>
        </Tooltip.Trigger>
        {label && <Tooltip.Panel>{label}</Tooltip.Panel>}
      </Tooltip>
    </div>
  )
}
